export const dataWarehouseUrls = {
  identityinfo:
    "https://beacon.wikia-services.com/__track/special/identityinfo",
  loadtime: "https://beacon.wikia-services.com/__track/special/adengloadtimes",
  chromelabels:
    "https://beacon.wikia-services.com/__track/special/chromelabels",
  consents: "https://beacon.wikia-services.com/__track/special/gdpr_events",
};
